import { render, staticRenderFns } from "./NewTeamForm.vue?vue&type=template&id=34b77784&scoped=true"
import script from "./NewTeamForm.vue?vue&type=script&lang=js"
export * from "./NewTeamForm.vue?vue&type=script&lang=js"
import style0 from "./NewTeamForm.vue?vue&type=style&index=0&id=34b77784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b77784",
  null
  
)

export default component.exports